import React from "react";
import Scroll2 from "./Scroll2";
import Download from "./Download";
import Service from "./Service";
import CommunitySection from "./services/CommunitySection";
import ServicesSection from "./services/ServicesSection";
import BlogSection from "./services/BlogSection";
import Footer from "./Footer";
import Navbar2 from "./Navbar2";

const Hero = () => {
  return (
    <>
      <Navbar2 />
      <ServicesSection />
      <Scroll2 />
      <Download />
      <CommunitySection />
      <BlogSection />
      <Service />
      <Footer />
    </>
  );
};

export default Hero;
